import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import { setPerPage, setDetails, fetchList, details } from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
// import AddComponent from "./components/Form/AddComponent";
// import EditComponent from "./components/Form/EditComponent";
import { ImportActivityBreadcrumb } from "../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
// import ImportComponent from "./components/Form/ImportComponent";
import React from "react";
import ViewDrawer from "./components/ViewDrawer";
import { CONSTANT } from "../../../config/Constant";
import { setViewLoading } from "../../../store/CommonSlice";
import { Space } from "antd";

const moduleInfo = {
  title: "Import Activity",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Import Activity"),
};

/**
 * Renders the Import Activity Management component.
 *
 * @return {ReactElement} The rendered Import ActivityManagement component.
 */
const ImportActivityManagement: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector((state) => state.experience);
  const [viewDrawer, setViewDrawer] = useState(false);

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);


  const getDetails = (data: any, type: string) => {
    dispatch(setViewLoading([true, data.id]));
    dispatch(details(data.id))
      .then(() => {
        if (type === CONSTANT.DRAWER_TYPE.VIEW) {
          setViewDrawer(true);
          dispatch(setViewLoading([false, data.id]));
        }

      })
      .catch((error: any) => error);
  };

  return (
    <>
      {/* <Space direction="vertical" size="small" style={{ display: 'flex' }}> */}
      <div style={{ marginBottom: '2rem' }}>
        <ToolBar breadcrumbs={ImportActivityBreadcrumb} >

          <RecordPerPage
            perPage={perPage}
            onChange={(perPageSize: number) => {
              dispatch(setPerPage(perPageSize));
            }}
          />
        </ToolBar>
      </div>
      <ContentBox >
        <Listing
          moduleInfo={moduleInfo}
          handleViewClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.VIEW);
          }}
        />
        <ViewDrawer
          titleName={moduleInfo.title}
          open={viewDrawer}
          close={() => dispatch(setDetails(null)) && setViewDrawer(false)}
        />

      </ContentBox>

      {/* </Space> */}
    </>
  );
};

export default ImportActivityManagement;
